import { Injectable, EventEmitter, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  public subject = new BehaviorSubject<any>(false)
  public step1Data = new BehaviorSubject<any>([])
  public step2DataExt = new BehaviorSubject<any>([])
  public step2DataInt = new BehaviorSubject<any>([])
  public visitDetails = new BehaviorSubject<any>({})
  public searchData = new BehaviorSubject<any>({})
  public visitId = new BehaviorSubject<any>(null)
  public issueId = new BehaviorSubject<any>(null)
  public groupId = new BehaviorSubject<any>(null)
  public useEmailSubject = new BehaviorSubject<string>('user')

 
  userAuthenticated = new EventEmitter();
  role = new EventEmitter();
  languageChanged = new EventEmitter();
  internalAdded = new EventEmitter();
  externaladded = new EventEmitter();
  windowResized = new EventEmitter();
  visitCreated = new EventEmitter();
  contactPersonAdded = new EventEmitter();
  email$ = this.useEmailSubject.asObservable();

  constructor() {}

  setEmail(value : string){
    this.useEmailSubject.next(value);
  }
  getEmail(): string{
    return this.useEmailSubject.value;
  }
  show(){
    this.subject.next(true);
  }
  hide(){
    this.subject.next(false);
  }

  setStep1Data(data : any) {
    this.step1Data.next(data);
  }

  setStep2DataExt(participants : any) {
    this.step2DataExt.next(participants);
  }
  seStep2DataInt(participants: any){
    this.step2DataInt.next(participants);
  }

  setVisitDetails(visit: any){
    this.visitDetails.next(visit);
  }

  setSearchData(data: any){
    this.searchData.next(data);
  }

  setVisitId(id: number){
    this.visitId.next(id)
  }

  setIssueId(id: number){
    this.issueId.next(id)
  }

  setGroupId(id: number){
    this.groupId.next(id)
  }

}
